<template lang="pug">
.blue-shadow
  img(src="~assets/card-shadow.png")
  
</template>
<script>
export default {
  name: 'BlueShadow',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.blue-shadow
  position: absolute
  width: pxToRem(612)
  height: pxToRem(190)
  left: pxToRem(-15)
  bottom: pxToRem(-60)
  z-index: -1
  opacity: 1
  img
    width: 100%
</style>
